import React, {Component} from 'react';
import axios from 'axios';
import {SERVER_URL}  from '../Constants';
import auth0Client from '../Auth';
import BootstrapTable from 'react-bootstrap-table-next';
import {ToastContainer, ToastStore} from 'react-toasts';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import ReactImageMagnify from 'react-image-magnify';
import Modal from 'react-responsive-modal';

const CELL_FONT_SIZE = '12px'

const { SearchBar } = Search;
const defaultSorted = [{
    dataField: '_created_at',
    order: 'desc'
  }];
  




class BoxImporter extends Component {
    constructor(props) {
      super(props);
        this.state = {
            bounteBoxItems:[],
            filteredBounteBoxItems:[],
            bounteBoxItemsCount:0,
            isLoading:false,
            selectedImageUrl:'',
            selectedRows:[],
            checkedCount:0,
            actionButtonDisabled:true,
            boxItem:undefined,
            displayLargeImageModal:false
        }
        this.rowEvents = {
            onClick: (e, row, rowIndex) => {
            
              // Check of this element is a TD containing a checkbox
              if (e.target.hasChildNodes()){
                if (e.target.childNodes[0].type==='checkbox'){
                  //console.log('ignore');
                  return;
                }
              }
              if (e.target.type==='checkbox') {return;}
            
              this.setState({
                boxItem: row,
              })
             
            },
            
          };
    }

    async componentDidMount() {
        this.loadBounteBoxData();
    }


    loadBounteBoxData= async()=>{
        axios.post(`${SERVER_URL}/box/queryboxitems/`,
        {
          statusCd : 'Q'
        },
        {
          headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId' : auth0Client.getActiveVenuedId()
         }
        }).then((res)=>{
         //console.log(res.data)
          this.setState({
            bounteBoxItems :res.data,
            filteredBounteBoxItems:res.data,
            bounteBoxItemsCount: (res.data)?res.data.length : 0,
            selectedRows:[]
          })
        })
      }


      removeFromList=(id)=>{
       let list= this.state.bounteBoxItems;
       for (var i=0; i<list.length; i++){
            if (list[i]._id===id){
                list.splice(i,1);
                break;
            }
       }
       return list;
      }

      // iterate through the list
      // set the targetStatus and new description

      importBulk=async(statusCd)=>{
            if (statusCd==='Q'){ if (!window.confirm('Are you sure you want to import the selected items?')) { return; }}
            if (statusCd==='D'){ if (!window.confirm('Are you sure you want to donate the selected items?')) { return; }}
            if (statusCd==='T'){ if (!window.confirm('Are you sure you want to Dispose the selected items?')) { return; }}
            try{
              

                let items=[];
                for (var i=0; i<this.state.selectedRows.length;i++){
                    let id =  this.state.selectedRows[i];
                    items.push(
                        {
                            id:id,
                            targetStatusCd:statusCd,
                            shortDescription:this.state.filteredBounteBoxItems.find(el=>el._id===id).shortDescription
                        }
                    )
                }
               
                this.setState({isLoading:true})
                axios.put(`${SERVER_URL}/box/importboxitems/`,
                {
                    items : items
                },
                {
                  headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
                  'venueId' : auth0Client.getActiveVenuedId()
                 }
                }).then((res)=>{
                 
                  if (res.status!==200){
                    ToastStore.error("An error occured. Please try again");
                  }
                  ToastStore.success("Successfully imported");
                     
                this.setState({isLoading:false});
                this.loadBounteBoxData(); 
    
                }).catch((e)=>{
                    this.setState({isLoading:false});
                    ToastStore.error(e.message);
                }); 

            }catch(e){
                alert(e.message)
            }
      }

      //import the item to the main Lost and Found
      import=(id)=>{

        try {
            this.setState({isLoading:true})
            axios.put(`${SERVER_URL}/box/importboxitems/`,
            {
                id : id
            },
            {
              headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId' : auth0Client.getActiveVenuedId()
             }
            }).then((res)=>{
             
              if (res.status!==200){
                ToastStore.error("An error occured. Please try again");
              }
                // remove the item from the list
                let newList= this.removeFromList(id);
                this.setState({
                    bounteBoxItems :newList,
                    bounteBoxItemsCount: (newList)?newList.length : 0
                })
                this.setState({isLoading:false});

            }).catch((e)=>{
                this.setState({isLoading:false});
                ToastStore.error(e);
            });  
        } catch (error) {
            this.setState({isLoading:false});
        }
       

        }
        //import the item to the main Lost and Found
        ignore=()=>{
            
             if (!window.confirm('Are you sure you want to ignore the selected items?')) { return; }
  
            
            try {
                
           
            let items=[];
            for (var i=0; i<this.state.selectedRows.length;i++){
                let id =  this.state.selectedRows[i];
                items.push(
                    {
                        id:id,
                    }
                )
            }

            axios.put(`${SERVER_URL}/box/ignore/`,
            {
                items : items
            },
            {
            headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId' : auth0Client.getActiveVenuedId()
            }
            }).then((res)=>{
               
            if (res.status!==200){
                ToastStore.error("An error occured. Please try again");
            }
               
            this.loadBounteBoxData();   
            }).catch((e)=>{
                ToastStore.error(e);
            });
        } catch (error) {
                
        }
    }
      

     getColumns =()=>{
         
        let columns=[

         
 
            { dataField: 'url', editable:false, text: 'Picture', formatter: this.imageFormat,headerAlign: 'center', headerStyle: {width:'100px'}  },
            { dataField: 'shortDescription', editable:true, classes:'text-primary', sort: true, formatter:this.shortDescriptionFormatter,style:{cursor: 'pointer' }, text: 'Item', filterable:true,  headerAlign: 'center', textAlign: 'left', headerStyle: { wordBreak: 'break-word', overflowWrap: 'break-word',}},
            { dataField: '_created_at', editable:false, sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found On',headerAlign: 'center',   style:{cursor: 'pointer'},headerStyle: { width: '190px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer'}},
            { dataField: 'locationFound',editable:false,sort: true, classes:'text-primary',hidden:false, text: 'Found near', headerAlign: 'center', filterable:false,  align: 'center', },
            { dataField: 'email',editable:false, sort: true, classes:'text-primary',hidden:false, text: 'Found By', headerAlign: 'center', filterable:false,  align: 'center', },
            { dataField: 'currentLocation',editable:false, sort: true, classes:'text-primary',hidden:false, text: 'Current Loc.', headerAlign: 'center', filterable:false,  align: 'center', },

           // { dataField: '_id',classes:'text-primary',hidden:false, text: '', headerAlign: 'center',formatter:this.rowActions, filterable:false,  align: 'center', headerStyle: { width: '220px'} },
     
        ];
     return columns
    }

    shortDescriptionFormatter=(cell,row)=>{
        return (
            <div className='col text-left text-info' style={{background: 'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACKklEQVR4nO2YT0sbQRjG30uthxYkuSjU3lR6UsFbD/YD5DN47UlEB0lSPHsolYytkKVVpOktSFIIFEVMYmOMO20jlV6KCNUmapRQE1BmT2+ZaIJ/Esj+0WxwfvAcd3l+s7PsvAtgU/ZGRx1ZQpJZQrb/jo93QTMRXFx3/PF6E1lC8CKZppEIx2Jt4egaiyzFtnbdnmJZIjM2drA/MvIM7Iwa8jjDK2vpz9EkikSWYj933e6KRJaQ32BXcB7a0A/fUpHX8bLAhUTlSWQISYCdy6MCKFJNYs/jTYgXG+xeHqtJrCQ3Q8uqE5qlPF6WsG35D+BABdK1ypfihx+/gk20bfBq+U18B067lmey/F0jV14vb9hZp0/VFijjRco0NBp/KoeHgYHaL6sCePSxF5X1/SrX86KPaSEf4z26y1PG82aKmy+vXRbJT2+cPqlb4HzlzZUXYXEvarOPapbPBfpRSR3Ue79g3QJmt005ha/deBzvR23uscGV1yrxMV7QIXD1YjAArrZ24upDLCXasoXvoaj3I0WN9rBCYOpV30z6UzvekNDxhaWNFBh++Xx70OXC74GOc4F4yw5+eTApzkC33oNaIDA09OKfkJia6HuLidanRu5BGylgBVQKMPkETEHlFmJyC5mC3uMtxC05zFkalZ/ULSCGiIYXZtdOo6q2oEOA91gx0FgXnqcpru/3upiAxBAhzuENW3XGC6XhSm95iUQikUgkEokE7oL/b1qVhrpVUOsAAAAASUVORK5CYII=")', backgroundRepeat: 'no-repeat', backgroundAttachment: 'scroll', backgroundSize: '24px 24px', backgroundPosition: '98% 50%', cursor: 'pointer'}} >
                <p className='text-info' style={{fontSize:'14px'}}><b>{row.shortDescription} </b>
                </p>  
            </div>
        )
    }

     imageFormat=(cell, row)=>{
       
       if (row.url){
        
         return (
          
            // <img  src={PARSE_SERVER_FILES_URI  + cell} width={75} height={65} alt={row.shortDescription} style={{cursor:'zoom-in'}} />
              <img  src={row.url} width={75} height={65} alt={row.shortDescription} style={{cursor:'zoom-in'}} />
         
         );
       }else{
         return (
           <img  src='../default-placeholder.png' width={75} alt={row.shortDescription} />
       )
       }
   }
   
   
 rowActions=(cell,row)=>{
      
       if (cell){
           return (
               <div>
                     <button className="btn btn-success btn-sm" title='Import' type="button" onClick={()=>{this.import(row._id)}}>Import</button>
                   
                     <button className="btn btn-link-danger btn-sm" title="Ignore" type="button" onClick={()=>{this.ignore(row._id)}}>Ignore</button>
                   
               </div>
           )
   
       }
       
   }

   renderActions=()=>{

   }

      renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }
   
    renderWait =()=>{
        if (this.state.isLoading){
            return (
                <div style={{zIndex:999, top:0, left:0, bottom:0, right:0, position:'absolute',  backgroundColor:'rgba(0, 0, 0, .8)', color: 'white'}}>
                    <div className='row'>
                    <div className='col text-center'>
                        <h5 style={{color:'white', fontSize:'19px'}}> Processing....</h5>
                        <hr/>
                    </div>
                </div>
                   </div>
            )
        }
    }

    renderLargeImage=()=>{

      return(
    
     
          <Modal open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
              <ReactImageMagnify  style={{width:700, height:600}} enlargedImagePosition='over' {...{
                                        smallImage: {
                                            alt: this.state.shortDescription,
                                            isFluidWidth: false,
                                            src: this.state.selectedImageUrl,
                                            width:700,
                                            height:600
                                        },
                                        largeImage: {
                                            src: this.state.selectedImageUrl,
                                            width: 1800,
                                            height: 1600
                                        },
                                        isHintEnabled: true,
                                        shouldHideHintAfterFirstActivation: false
                                    }} />
           
              <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>
          </Modal>
    
          )
    }

    render() {
       
        return(
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h5>BOUNTE Box and Remote importer</h5>
                        <hr/>
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col' style={{maxHeight:'550px',overflow:'auto',display:'inline-block'}}>
                    <ToolkitProvider 
                            bootstrap4
                            keyField='_id' 
                            data={ this.state.filteredBounteBoxItems } 
                            columns={ this.getColumns()} 
                            defaultSorted={defaultSorted}
                            search
                            >
                           {
                           props => (
                                <div>
                                 <div className='row '>
                                   
                                    <div className='col-3 text-center' >
                                            <SearchBar { ...props.searchProps } />
                                    </div>
                                    <div className='col-9 text-right' >
                                        <button className="btn btn-success btn-sm" style={{paddingRight:'20px'}} title='Import' type="button" onClick={()=>{this.importBulk('Q')}} disabled={this.state.actionButtonDisabled || auth0Client.lfReadOnly===true}>Import</button>              
                                        <button className="btn btn-warning btn-sm" style={{paddingRight:'20px'}}  title='Dispose' type="button" onClick={()=>{this.importBulk('T')}} disabled={(this.state.actionButtonDisabled || auth0Client.lfReadOnly===true)}>Dispose</button>              
                                        <button className="btn btn-info btn-sm" style={{paddingRight:'20px'}} title='Donate' type="button" onClick={()=>{this.importBulk('D')}} disabled={(this.state.actionButtonDisabled || auth0Client.lfReadOnly===true)}>Donate</button>  
                                        <button className="btn btn-link-danger btn-sm" style={{paddingRight:'20px'}}  title="Ignore" type="button" onClick={()=>{this.ignore()}} disabled={(this.state.actionButtonDisabled || auth0Client.lfReadOnly===true)} >Ignore</button>            

                                        
                                    </div>
                                </div>
                                <div className='row '>
                                     <div className='col-12 text-right' >
                                                        <BootstrapTable
                                                        
                                                                style={{height:'250px'}}
                                                                className="table-sm"
                                                                ref={this.tableRef}
                                                                striped
                                                                hover
                                                                condensed
                                                                rowEvents={this.rowEvents}
                                                                { ...props.baseProps }
                                                                cellEdit={ 
                                                                    cellEditFactory({ 
                                                                        mode: 'click',  
                                                                        blurToSave:true,
                                                                        afterSaveCell: (oldValue, newValue, row, column) => { 
                                                                            if (newValue && newValue.trim()!==''){
                                                                                row.shortDescription = newValue;
                                                                              
                                                                            }else{
                                                                                row.shortDescription = oldValue;
                                                                            }
                                                                            
                                                                         }
                                                                    })
                                                                }
                                                                selectRow={ { 
                                                                    mode: 'checkbox', 
                                                                    clickToSelect: true, 
                                                                    clickToEdit: true,
                                                                    selected:this.state.selectedRows,
                                                                    onSelect: (row, isSelect, rowIndex, e) => {
                                                                      if (e.target.tagName.toLowerCase() === 'img'){
                                                                        //console.log('onSelect');
                                                                        e.stopPropagation(); //dont check
                                                                        this.setState({
                                                                          selectedImageUrl : e.target.src,
                                                                          displayLargeImageModal:true});
                                                                         
                                                                        return;
                                                                      }
                                                                          let index = this.state.selectedRows.indexOf(row._id);  
                                                                          if (isSelect){
                                                                            if (index===-1) {
                                                                              this.state.selectedRows.push(row._id);
                                                                            }
                                                                          }else { this.state.selectedRows.splice(index, 1) }
                                                                       
                                                                        this.setState({
                                                                          checkedCount:this.state.selectedRows.length,
                                                                          actionButtonDisabled:(this.state.selectedRows.length===0)
                                                                        })
                                                                      },
                                                                      onSelectAll: (isSelect, rows, e) => {
                                                                        let selectedRowList = this.state.selectedRows;
                                                                        selectedRowList.length=0; //cleared
                                                                        //this.cleanSelectedCheckboxes();
                                                                        if (isSelect){
                                                                          // clear and loop and add each
                                                                          
                                                                          for(var i=0;i<rows.length; i++) { this.state.selectedRows.push(rows[i]._id)}
                                                                        }else{
                                                                          this.setState({selectedRows:[]});
                                                                        }
                                                                        this.setState({
                                                                          checkedCount:this.state.selectedRows.length,
                                                                          actionButtonDisabled:(this.state.selectedRows.length===0)
                                                                        })
                                                                      },
                                                                      selectionRenderer: (props) => (
                                                                        <input
                                                                            style={{width:'20px', height:'20px', alignSelf:'center'}}
                                                                            type={props.mode}
                                                                            checked={props.checked}
                                                                            onChange={()=>{}}
                                                                        />
                                                                      )
                                                                }
                                                            }

                                                        />
                                        </div>
                                    </div>
                                </div>
                            )}
                           
                            </ToolkitProvider>
                      
                        </div>
                    </div>
                    {this.renderLargeImage()}
                    {this.renderWait()}
                    {this.renderToast()}
            </div>
        )

    }



}



export default BoxImporter

